import React from "react"
import { useMoveWrapStyle } from "./style"
interface ComponentProps {
    children: React.ReactNode,
}
export default (props: ComponentProps) => {
    const classes = useMoveWrapStyle()
    const { children } = props
    return (
        <div className={classes.root}>{ children }</div>
    )
}

